module.exports = "<style></style> <svg width=100% height=${this.svgVisina}px> ${this.putanje} </svg> ${this.scene} ${this.datumi} <button id=sacuvaj type=submit class=pozadina-belo>Sačuvaj</button> ";


//////////////////
// WEBPACK FOOTER
// ./src/komponente/editor/sablon.html
// module id = 32
// module chunks = 0